export function debounce(fn, wait, cancel = () => {}) {
	let timeout, isExecuting = false;

	return (...args) => {
		clearTimeout(timeout)

		if (isExecuting) {
			isExecuting = false
			cancel()
		}

		timeout = setTimeout(() => {
			isExecuting = true
			fn.apply(this, args)
		}, wait)
	};
}

export function asyncDebounce(fn, wait, cancel = () => {}) {
	let timeout, isExecuting = false;

	return (...args) => {
		return new Promise((resolve, reject) => {
			clearTimeout(timeout)

			if (isExecuting) {
				isExecuting = false
				cancel()
			}

			timeout = setTimeout(() => {
				isExecuting = true
				resolve(fn.apply(this, args))
			}, wait)
		})
	}
}
